import { ICellRendererParams } from 'ag-grid-community';
import { Label } from 'react-bootstrap';
import { PrimaryGoalType } from '@nkr/enums/primary-goal';

const PrimaryGoalLabel = (params: ICellRendererParams) => {
    const goal = params.data?.selectedGoal;
    
    // Return N/A without label if no goal
    if (goal === undefined || goal === null || goal === -1) {
        return <>N/A</>;
    }

    let displayText = 'N/A';
    let style = 'default';

    switch (goal) {
        case PrimaryGoalType.TransferToMicrositeCenter:
            displayText = 'MS';
            style = 'info';
            break;
        case PrimaryGoalType.TransferToKidneyForLifeCenter:
            displayText = 'KFL';
            style = 'info';
            break;
        case PrimaryGoalType.TransferToImmunoFreeCenter:
            displayText = 'Immuno Free';
            style = 'info';
            break;
        case PrimaryGoalType.StandardVoucher:
            displayText = 'Standard Voucher';
            style = 'info';
            break;
        case PrimaryGoalType.FindCenter:
            displayText = 'Find Center';
            style = 'info';
            break;
        case PrimaryGoalType.UnderstandOptions:
            displayText = 'Understand Options';
            style = 'info';
            break;
        case PrimaryGoalType.Other:
            displayText = 'Other';
            style = 'info';
            break;
    }

    return <Label bsStyle={style}>{displayText}</Label>;
};

export default PrimaryGoalLabel; 